import { defineBoot } from '#q-app'
import type { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import axios, { AxiosHeaders } from 'axios'
import axiosRetry from 'axios-retry'
import { client } from 'laravel-precognition'
import type { QNotifyOptions } from 'quasar'
import { Notify } from 'quasar'
import * as AppIcons from '../css/AppIcons'

declare module 'vue' {
  interface ComponentCustomProperties {
    $axios: AxiosInstance
    $api: AxiosInstance
  }
}
const api = axios.create({
  baseURL: import.meta.env.CLI_API_BASE_URL,
  withCredentials: true,
  //headers: { Accept: 'application/json' },
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  withXSRFToken: true,
})

//@ts-ignore
client.use(api)

axiosRetry(api, {
  retries: 5,
  // eslint-disable-next-line @typescript-eslint/unbound-method
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (error) => axiosRetry.isNetworkError(error),
  onMaxRetryTimesExceeded: () => {
    Notify.create({
      message: 'Ошибка соединения. Проверьте соединение с интернетом и повторите запрос',
      position: 'center',
      type: 'negative',
    })
  },
})

// Define types for the request queue items
/*interface RequestQueueItem {
  config: AxiosRequestConfig;
  resolve: (value: AxiosResponse<any>) => void;
  reject: (reason?: any) => void;
}

// Queue to hold pending requests
const requestQueue: RequestQueueItem[] = [];
let batchTimeout: NodeJS.Timeout | null = null;*/

// Function to process the batch
export default defineBoot(({ app /*router*/ }) => {
  app.config.globalProperties.$axios = axios

  app.config.globalProperties.$api = api

  api.interceptors.response.use(
    (response: AxiosResponse) => {
      if (response.data.notifications) {
        response.data.notifications.forEach((notification: QNotifyOptions) => {
          notification.icon = notification.icon
            ? (AppIcons[notification.icon as keyof typeof AppIcons] ?? undefined)
            : undefined
          Notify.create(notification)
        })
      }
      return response
    },
    async (error: AxiosError & { response?: { data?: any } }) => {
      if (error.status) {
        if (error.status >= 500) {
          Notify.create({
            message: error.response?.data?.message ?? 'Ошибка сервера',
            position: 'center',
            type: 'negative',
            closeBtn: true,
          })
        } else if (error.status === 429) {
          Notify.create({
            message:
              error.response?.data?.message ??
              'Слишком много запросов. Повторите ваш запрос позже.',
            position: 'center',
            type: 'negative',
            closeBtn: true,
          })
        } /*else if (error.status === 401) {
          await router.push('/');
          return;
        }*/ else if (error.status === 403) {
          Notify.create({
            message:
              error.response?.data?.message ?? 'У вас нет прав на выполнение данного действия',
            position: 'center',
            type: 'negative',
            closeBtn: true,
          })
          //await router.push('/');
        } else if (error.status === 400) {
          let message = 'Данные устарели, пожалуйста обновите страницу'
          const data = error.response?.data
          if (data instanceof Blob) {
            try {
              message = JSON.parse(await data.text()).message ?? message
            } catch {
              /* не JSON — оставляем как есть */
            }
          } else if (data?.message) {
            message = data.message
          }
          Notify.create({
            message: message,
            position: 'center',
            type: 'warning',
            //actions: [{ label: 'Обновить', onClick: () => window.location.reload() }],
          })
        } else if (error.status === 409) {
          Notify.create({
            message: error.response?.data?.message,
            position: 'center',
            type: 'warning',
            closeBtn: true,
          })
        } else if (error.status === 404) {
          // await router.replace('/404');
        } else if (error.status === 419 && error.config) {
          await api.get('sanctum/csrf-cookie')
          return axios.request(error.config)
        }
      }
      throw error
    },
  )
  /*
  const processBatch = () => {
    // Extract routes and promises from the queue
    const routes = requestQueue.map(({ config }) => config.url);
    const originalPromises = requestQueue.map(({ resolve, reject }) => ({ resolve, reject }));

    requestQueue.length = 0;

    // Make the batch request
    api.post('/api/batch', { routes })
      .then(response => {
        const responseData: any[] = response.data;

        // Map the batch response back to individual requests
        originalPromises.forEach(({ resolve }, index) => {
          resolve({ ...response, data: responseData[index] });
        });
      })
      .catch(error => {
        // Reject all promises if the batch request fails
        originalPromises.forEach(({ reject }) => reject(error));
      });
  };
  // Axios interceptor to batch GET requests
  api.interceptors.request.use((config) => {
    // Only batch GET requests
    if (config.method === 'get') {
      return new Promise<AxiosResponse>((resolve, reject) => {
        requestQueue.push({ config, resolve, reject });

        // Start or reset the batch timeout
        if (batchTimeout) {
          clearTimeout(batchTimeout);
        }
        batchTimeout = setTimeout(processBatch, 50); // 50ms window to batch requests
      }) as unknown as InternalAxiosRequestConfig<any>;
    }

    // Return other requests as usual
    return config;
  });*/
  api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const headers = new AxiosHeaders(config.headers || {})
    /*if (router.currentRoute.value.query.XDEBUG_SESSION) {
      config.params = {
        ...config.params,
        XDEBUG_SESSION: router.currentRoute.value.query.XDEBUG_SESSION,
      }
    }*/
    if (config.method?.toUpperCase() === 'PUT' && !!config.data) {
      // Используем существующие заголовки или пустой объект
      headers.set('X-HTTP-Method-Override', 'PUT')
      config.method = 'POST'
      config.data._method = 'PUT'
    }
    return config
  })
})

export { api }
